import {
  Stack, Typography, useTheme, Switch
} from '@mui/material'
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import RpIcon from "@/components/RpIcon";
import React, {useEffect, useMemo, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import { useBoolean } from "ahooks";
import CurrencyList from '@/components/CurrencyList'
import { useConfirm } from "material-ui-confirm";
import { useRequest } from "ahooks";
import { orderBy } from "es-toolkit/array";
import {getCardFiatSetting, setCardFiatSetting, setCardFiatSettingStatus} from '@/services/card'
import { StyledSwitch } from "@/styles/CommonStyledComponents";
import {getUrlParams} from "@/utils/utils";
const PaymentCurrencySetting = () => {
  const cardId = getUrlParams("cardId");
  const navigate = useNavigate();
  const { t } = useTranslation()
  const theme = useTheme()

  const [showCurrencyList, showCurrencyListOperate] = useBoolean(false);
  const [allCurrencyList, setALLCurrencyList] = React.useState([]);
  const confirm = useConfirm()

  const getCardFiatSettingReq = useRequest(async () => {
    const res = await getCardFiatSetting({ cardId: cardId });
    return res
  }, { manual: false });

  const [checkedCurrencyList, setCheckedCurrencyList] = useState([])

  useEffect(() => {
    if (!getCardFiatSettingReq?.data) {
      return
    }
    let result = getCardFiatSettingReq?.data?.settings.filter(_ => {
      return _.isEnable == 1
    })
    setCheckedCurrencyList(result)
  }, [getCardFiatSettingReq?.data])



  useEffect(() => {
    if (!checkedCurrencyList.length || !allCurrencyList.length) {
      return
    }

    if (checkedCurrencyList.length >= allCurrencyList.length) {
      confirm({
        title: t('currency_tips'),
        content: t('all_select_currency'),
        hideCancelButton: true
      })
    }
  }, [checkedCurrencyList, allCurrencyList]);

  const setCardFiatSettingStatusReq = useRequest(async (_showCurrencyList) => {
    let params: any = {
      cardId
    }
    params = {
      ...params,
      payAllowCurrencyStatus: _showCurrencyList ? 1 : 0
    }
    const res = await setCardFiatSettingStatus(params);
    return res
  }, { manual: true });

  const setCardFiatSettingReq = useRequest(async (_enableCurrencyCodes) => {
    let params: any = {
      cardId
    }
    params = {
      ...params,
      enableCurrencyCodes: _enableCurrencyCodes
    }
    const res = await setCardFiatSetting(params);
    return res
  }, { manual: true });

  useEffect(() => {
    if (!getCardFiatSettingReq.data) {
      return
    }
    if (getCardFiatSettingReq.data?.enable) {
      showCurrencyListOperate.setTrue()
    } else {
      showCurrencyListOperate.setFalse()
    }
  }, [getCardFiatSettingReq.data]);

  useEffect(() => {
    if (showCurrencyList) {
      showNoneSelectCurrency()
    }
  }, [showCurrencyList]);

  const showNoneSelectCurrency = () => {
    // confirm({
    //   title: t('tips'),
    //   hideCancelButton: true,
    // })
  }

  const onCurrencyChange = (list) => {
    const checkedList = list.filter(_ => _.isChecked)
    if (checkedList.length <= 0) {
      confirm({
        title: t('currency_tips'),
        content: t('at_least_one_currency'),
        hideCancelButton: true
      }).then(() => {
        setCheckedCurrencyList([list[0]])
      })


    }
    if (checkedList.length >= list.length) {
      confirm({
        title: t('currency_tips'),
        content: t('all_select_currency'),
        hideCancelButton: true
      })
    }
    setCardFiatSettingReq.runAsync(checkedList.map(_ => _.code)).then(() => {
      getCardFiatSettingReq.runAsync()
    })
  }

  return (
    <Stack
      direction="column"
    sx={{
     height: '100%'
    }}
    >
      <SimpleHeader
        title={t('payment_currency_settings')}
        closeButton={
          <RpIcon icon="arrow-left" clickable
                  onClick={() => {
                    navigate(-1)
                  }} />
        }
        backEnable
      />
      <Stack
        sx={{
          padding: '8px 12px',
          backgroundColor: theme.palette.background.card,
          color: theme.palette.text.secondary,
        }}
        direction="row" alignItems="flex-start" gap="4px">
        <RpIcon icon="info" size={16} />
        <Typography
        sx={{
          fontSize: '12px !important',
          lineHeight: '14px',
        }}
        >
          {t('disable_non_local_tip')}
        </Typography>
      </Stack>
      <Stack
        sx={{
          margin: '12px 0',
          padding: '8px 12px',
          backgroundColor: theme.palette.background.card,
          height: '72px'
        }}
        direction="row" alignItems="center" justifyContent="space-between" gap="8px">
        <Typography
          sx={{
            fontSize: '16px',
          }}
        >
          {t('customize_payment_currency')}
        </Typography>
        <StyledSwitch
          checked={showCurrencyList}
          onChange={(event) => {
            setCardFiatSettingStatusReq.runAsync(event.target.checked).then(() => {
              getCardFiatSettingReq.runAsync()
            })
            showCurrencyListOperate.set(event.target.checked);
            if (!event.target.checked) {
              confirm({
                title: t('currency_tips'),
                content: t('all_select_currency'),
                hideCancelButton: true
              })
            } else {
              confirm({
                title: t('currency_tips'),
                content: t('at_least_one_currency'),
                hideCancelButton: true
              })
            }
          }}
          
        />
      </Stack>
      {showCurrencyList &&
        <Stack sx={{ padding: '0 16px', height: '400px', flex: 1, backgroundColor: 'transparent', overflow: 'auto' }}>
          <CurrencyList
            onChange={onCurrencyChange}
            onLoad={(list) => {
              setALLCurrencyList(list)
            }}
            checkedCurrencyList={checkedCurrencyList} />
        </Stack>
        }
    </Stack>
  )
}

export default PaymentCurrencySetting;